import TopRankUniCard from "@modules/study/common/top_rank_uni_card";
import { Grid } from "@mui/material";
import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import styles from "./uni_overview_popular_university.module.scss";

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <FiChevronRight className={"ReviewSliderTextArrowNext"} onClick={onClick} />
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <FiChevronLeft className={"ReviewSliderTextArrowPrev"} onClick={onClick} />
  );
}

const settings = {
  dots: true,
  className: "TopRankCardSlider",
  centerMode: false,
  infinite: true,
  centerPadding: "60px",
  slidesToShow: 3,
  speed: 500,
  rows: 2,
  arrows: false,
  // slidesPerRow: 1,
  slidesToScroll: 3,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        arrows: false,
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 900,
      settings: {
        arrows: false,
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 750,
      settings: {
        rows: 1,
        arrows: true,
        dots: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export const UniOverviewPopularUniversity = () => {
  return (
    <section>
      <div className="container">
        <div className={styles.title_wrapper}>
          <h2>Popular Universities</h2>
          <p className={styles.short_description}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dictum nunc
            donec vulputate ut in sapien nunc, sit. Amet, viverra arcu est,
            imperdiet. Porta sollicitudin tempus odio gravida eget.
          </p>
        </div>

        <div
          className={`top-rank-slider-wrapper ${styles.top_rank_card_wrapper}`}
        >
          <Grid container spacing={4}>
            <Grid item md={4} sm={12} xs={12}>
              <TopRankUniCard />
            </Grid>
            <Grid item md={4} sm={12} xs={12}>
              <TopRankUniCard />
            </Grid>
            <Grid item md={4} sm={12} xs={12}>
              <TopRankUniCard />
            </Grid>
            <Grid item md={4} sm={12} xs={12}>
              <TopRankUniCard />
            </Grid>
            <Grid item md={4} sm={12} xs={12}>
              <TopRankUniCard />
            </Grid>
            <Grid item md={4} sm={12} xs={12}>
              <TopRankUniCard />
            </Grid>
          </Grid>
        </div>
      </div>
    </section>
  );
};

export default UniOverviewPopularUniversity;
